import React, { useState, useEffect, useRef, useMemo } from "react";

import CCService from "../services/cc.service";
//import Table from 'react-bootstrap/Table'
import MUIDataTable from "mui-datatables";
import CCCard from "./CCCard";
import CardMobile from "./CardMobile";
import { useMediaQuery } from "react-responsive";
import { Modal, Button, Image } from "react-bootstrap";
import { Container, Row, Col } from "react-bootstrap/";

import Lottie from "react-lottie";

import * as lapiz from "../assets/reloj.json";

import { EraserFill, FileEarmarkSpreadsheet } from "react-bootstrap-icons";
import { get } from "jquery";

const dayjs = require("dayjs");

const TablaCC = (tipo) => {
  const [content, setContent] = useState({ arts: [] });
  const [count, setCount] = useState({});
  const [elegido, setElegido] = useState(tipo.children);
  const isTabletOrMobile = useMediaQuery({ maxWidth: 1224 });

  const [fullscreen, setFullscreen] = useState(true);
  const [show, setShow] = useState(false);
  const [search, setSearch] = useState("");

  const containerRef = useRef(null);
  const [auxTextSearch, setAuxTextSearch] = useState("");

  // Modal //
  const [tituloModal, setTituloModal] = useState("");
  const [rowGuardada, setRowGuardada] = useState("");
  // Fin Modal //

  // Modal Card//
  const [tituloModalCard, setTituloModalCard] = useState("Art");
  const [fullscreenCard, setFullscreenCard] = useState(true);
  const [showCard, setShowCard] = useState(false);
  const [dataArt, setDataArt] = useState();
  // Fin Modal Camara//

  const [loadingExcel, setLoadingExcel] = useState(undefined);
  const [loadingData, setLoadingData] = useState(false);

  const [diaFiltro, setDiaFiltro] = useState("Todos");

  const diasSemana = [
    { key: "Todos", label: "Todos", short: "Todos" },
    { key: "SinDia", label: "Sin día", short: "Sin día" },
    { key: "Lunes", label: "Lunes", short: "Lun" },
    { key: "Martes", label: "Martes", short: "Mar" },
    { key: "Miércoles", label: "Miércoles", short: "Mié" },
    { key: "Jueves", label: "Jueves", short: "Jue" },
    { key: "Viernes", label: "Viernes", short: "Vie" },
    { key: "Sábado", label: "Sábado", short: "Sáb" },
    { key: "Día Especial", label: "Día Especial", short: "Esp" },
    { key: "Lunes 2", label: "Lunes 2", short: "Lun 2" },
    { key: "Martes 2", label: "Martes 2", short: "Mar 2" },
    { key: "Miércoles 2", label: "Miércoles 2", short: "Mié 2" },
    { key: "Jueves 2", label: "Jueves 2", short: "Jue 2" },
    { key: "Viernes 2", label: "Viernes 2", short: "Vie 2" },
    { key: "Sábado 2", label: "Sábado 2", short: "Sáb 2" },
    { key: "Día Especial 2", label: "Día Especial 2", short: "Esp 2" },
  ];

  const coincideDia = (diasDeVisita, diaBuscado) => {
    if (!diasDeVisita) return false;
    const diaBuscadoNorm = String(diaBuscado).toLowerCase().trim();
    const diasNorm = String(diasDeVisita).toLowerCase();
    if (diasNorm.trim() === diaBuscadoNorm) return true;
    const partes = diasNorm
      .split(/[,;]+/)
      .map((p) => p.trim())
      .filter((p) => p !== "");
    return partes.includes(diaBuscadoNorm);
  };

  const artsFiltrados = useMemo(() => {
    if (!content.arts) return [];
    if (diaFiltro === "Todos") return content.arts;
    if (diaFiltro === "SinDia") {
      return content.arts.filter((art) => {
        const dias = art.cliente?.DiasDeVisita;
        return !dias || String(dias).trim() === "";
      });
    }
    return content.arts.filter((art) =>
      coincideDia(art.cliente?.DiasDeVisita, diaFiltro)
    );
  }, [content.arts, diaFiltro]);

  const ordenDiasSort = [
    "Lunes",
    "Martes",
    "Miércoles",
    "Jueves",
    "Viernes",
    "Sábado",
    "Día Especial",
    "Lunes 2",
    "Martes 2",
    "Miércoles 2",
    "Jueves 2",
    "Viernes 2",
    "Sábado 2",
    "Día Especial 2",
    "SinDia",
  ];

  const getOrdenDelDiaData = (art) => {
    if (!art || !art.cliente) return null;
    const codigoVendedor = art.cliente.CodigoVendedor;
    const vendedor = codigoVendedor ? `V${codigoVendedor}` : "SinVendedor";
    const dias = art.cliente.DiasDeVisita;
    const dia =
      dias && String(dias).trim() !== ""
        ? String(dias).split(",")[0].trim()
        : "SinDia";
    const ordenValor = art.cliente.OrdenDeDia;
    if (
      ordenValor === null ||
      ordenValor === undefined ||
      ordenValor === -1
    ) {
      return null;
    }
    return { vendedor, dia, orden: ordenValor, text: `${vendedor}-${dia}-${ordenValor}` };
  };

  const getOrdenDelDiaSort = (art) => {
    if (!art || !art.cliente) return "ZZZ";
    const codigoVendedor = art.cliente.CodigoVendedor;
    const dias = art.cliente.DiasDeVisita;
    const dia =
      dias && String(dias).trim() !== ""
        ? String(dias).split(",")[0].trim()
        : "SinDia";
    const ordenValor = art.cliente.OrdenDeDia;
    if (
      ordenValor === null ||
      ordenValor === undefined ||
      ordenValor === -1
    ) {
      return "ZZZ";
    }
    const vendedorPadded = String(codigoVendedor || 9999).padStart(4, "0");
    const diaIdx = ordenDiasSort.indexOf(dia);
    const diaPadded = String(diaIdx >= 0 ? diaIdx : 99).padStart(2, "0");
    const ordenPadded = String(ordenValor).padStart(4, "0");
    return `V${vendedorPadded}-${diaPadded}-${ordenPadded}`;
  };

  const artsFiltradosConSort = useMemo(() => {
    return artsFiltrados.map((art) => ({
      ...art,
      ordenDelDiaSort: getOrdenDelDiaSort(art),
    }));
  }, [artsFiltrados]);

  const getData = () => {
    if (elegido === 0) {
      // Todos
      CCService.getTodos().then(
        (response) => {
          console.log(response.data);
          //response.data.map((articulo) => console.log(articulo));
          setContent({ arts: response.data });
          setLoadingData(true);
        },
        (error) => {
          const _content =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();

          setContent(_content);
          setLoadingData(true);
        }
      );
    }
    if (elegido === 1) {
      // Deudoras
      CCService.getDeudoras().then(
        (response) => {
          console.log(response.data);
          //response.data.map((articulo) => console.log(articulo));
          setContent({ arts: response.data });
          setLoadingData(true);
        },
        (error) => {
          const _content =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();

          setContent(_content);
          setLoadingData(true);
        }
      );
    }
    if (elegido === 2) {
      // Atrasadas
      CCService.getAtrasadas().then(
        (response) => {
          console.log(response.data);
          //response.data.map((articulo) => console.log(articulo));
          setContent({ arts: response.data });
          setLoadingData(true);
        },
        (error) => {
          const _content =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();

          setContent(_content);
          setLoadingData(true);
        }
      );
    }
  };
  useEffect(() => {
    if (navigator.geolocation) {
      console.log("Geolocalización disponible");
    } else {
      console.log("Geolocalización no disponible");
    }
    getData();
  }, []);

  const lapízOptions = {
    loop: true,
    autoplay: true,
    animationData: lapiz.default,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const columns = [
    {
      name: "idCuentaCorriente",
      label: "ID",
      options: {
        display: "excluded",
      },
    },
    {
      name: "cliente.Codigo",
      label: "Codigo",
      setCellProps: () => ({ style: { whiteSpace: "nowrap" } }),
    },
    {
      name: "cliente.RazonSocial",
      label: "Razón Social",
      setCellProps: () => ({ style: { whiteSpace: "nowrap" } }),
    },
    {
      name: "cliente.Direccion",
      label: "Dirección",
      setCellProps: () => ({ style: { whiteSpace: "nowrap" } }),
    },

    { name: "cliente.Cuit", label: "CUIT" },
    {
      name: "fechaUltimoPago",
      label: "Fecha Ultimo Pago",
      options: {
        display: false,
      },
    },
    {
      name: "saldo",
      label: "Saldo",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const nf = new Intl.NumberFormat("es-AR", {
            style: "decimal",
            currency: "ARS",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
          return nf.format(value);
        },
      },
    },
    {
      name: "diasAtrasado",
      label: "Dias Atrasado",
      options: {
        display: false,
      },
    },
    {
      name: "montoMaximo",
      label: "montoMaximo",
      options: {
        display: "excluded",
        customBodyRender: (value, tableMeta, updateValue) => {
          const nf = new Intl.NumberFormat("es-AR", {
            style: "decimal",
            currency: "ARS",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
          return nf.format(value);
        },
      },
    },
    {
      name: "clienteIdCliente",
      label: "clienteIdCliente",
      options: {
        display: "excluded",
      },
    },
    {
      name: "cliente.Lat",
      label: "Lat",
      options: {
        display: "excluded",
      },
    },
    {
      name: "cliente.Lng",
      label: "Lng",
      options: {
        display: "excluded",
      },
    },
    {
      name: "cliente.DiasDeVisita",
      label: "DiasDeVisita",
      options: {
        display: "excluded",
      },
    },
    {
      name: "cliente.Alias",
      label: "Alias",
      options: {},
    },
    {
      name:"cliente.DiasDeVisita",
      label:"Dias de Visita",
      options:{}
    },
    {
      name: "ordenDelDiaSort",
      label: "Orden del día",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          if (value === "ZZZ") return "";
          const partes = value.split("-");
          if (partes.length < 3) return value;
          const vendedor = `V${parseInt(partes[0].substring(1), 10)}`;
          const diaIdx = parseInt(partes[1], 10);
          const dia = ordenDiasSort[diaIdx] || "SinDia";
          const orden = parseInt(partes[2], 10);
          return `${vendedor}-${dia}-${orden}`;
        },
      },
    }
  ];

  const options = {
    filterType: "checkbox",
    onRowsDelete: () => {
      return false;
    },
    sortOrder:
      elegido === 2
        ? {
            name: "diasAtrasado",
            direction: "desc",
          }
        : null,
    rowsPerPageOptions: [100],
    selectToolbarPlacement: "replace",
    responsive: "standard",
    searchOpen: true,
    searchAlwaysOpen: true,
    searchPlaceholder: "Buscar Cuentas Corrientes",
    filter: false,
    expandableRows: true,
    expandableRowsHeader: false,
    expandableRowsOnClick: true,
    download: false,
    print: false,
    searchText: search,
    fixedHeader: true,
    fixedSelectColumn: true,
    enableNestedDataAccess: ".",
    selectableRows: "none",
    rowsExpanded: [],
    onRowClick: (rowData) => {
      let i  = 0;
      /*
      if (isTabletOrMobile) {
        let textoSearch = containerRef.current.state.searchText;
        console.log(rowData);
        setTituloModal(rowData[2]);
        setRowGuardada(rowData);
        setAuxTextSearch(textoSearch);
        setShow(true);
      }
      */
    },
    /*
  renderExpandableRow: (rowData, rowMeta) => {
    if(!isTabletOrMobile){
      const colSpan = rowData.length + 1;
      return (
        <TableRow>
          <TableCell colSpan={colSpan} >
            <Card>{rowData}</Card>
          </TableCell>
        </TableRow>
      );
    }
  },
  */
    renderExpandableRow: (rowData, rowMeta) => {
      /*
      if (!isTabletOrMobile) {
        let textoSearch = containerRef.current.state.searchText;
        setRowGuardada(rowData);
        setAuxTextSearch(textoSearch);
        setDataArt(rowData);
        setTituloModalCard(rowData[2]);
        setShowCard(true);
      }
      */
      let textoSearch = containerRef.current.state.searchText;
      setRowGuardada(rowData);
      setAuxTextSearch(textoSearch);
      setDataArt(rowData);
      setTituloModalCard(rowData[2]);
      setShowCard(true);
    },
    onRowExpansionChange: (curExpanded, allExpanded, rowsExpanded) => {
      console.log(curExpanded, allExpanded, rowsExpanded);
    },
  };

  const actualizarPadre = (devuelto) => {
    setSearch(devuelto);
  };

  const cerrarModal = () => {
    setSearch(auxTextSearch);
    setShow(false);
  };
  const cerrarModalCard = () => {
    setSearch(auxTextSearch);
    setShowCard(false);
    getData();
  };
  const limpiarSearchBox = () => {
    //TODO Mejorar esto la segunda vez no lo borra
    //containerRef.current.state.searchText = "";
    setSearch("");
    setAuxTextSearch("");
  };

  if (content.message !== "Su usuario no se encuentra habilitado") {
    return (
      <Container fluid>
        {loadingExcel ? (
          <Lottie options={lapízOptions} height={200} width={200} />
        ) : (
          <div>
            <Row className="d-flex justify-content-center">
              <Col>
                {!loadingData ? (
                  <Lottie options={lapízOptions} height={200} width={200} />
                ) : (
                  <div>
                    {isTabletOrMobile && elegido === 0 ? (
                      <Row className="d-flex justify-content-center">
                        <Col>
                          <Button
                            variant="light"
                            onClick={() => limpiarSearchBox()}
                          >
                            <EraserFill size={30} /> Limpiar Campos
                          </Button>
                        </Col>
                      </Row>
                    ) : (
                      console.log("")
                    )}
                    <Row className="mb-2 mt-3 justify-content-center">
                      {diasSemana.map((dia) => (
                        <Col key={dia.key} xs="auto" className="mb-2">
                          <Button
                            size={isTabletOrMobile ? "sm" : undefined}
                            variant={diaFiltro === dia.key ? "primary" : "outline-primary"}
                            onClick={() => setDiaFiltro(dia.key)}
                          >
                            {isTabletOrMobile ? dia.short : dia.label}
                          </Button>
                        </Col>
                      ))}
                    </Row>
                    <MUIDataTable
                      ref={containerRef}
                      title={"Lista de Cuentas Corrientes"}
                      data={artsFiltradosConSort}
                      columns={columns}
                      options={options}
                      id="tabla"
                    ></MUIDataTable>
                  </div>
                )}
              </Col>
            </Row>
            <Modal
              show={show}
              fullscreen={fullscreen}
              onHide={() => setShow(false)}
            >
              <Modal.Header>
                <Modal.Title>{tituloModal}</Modal.Title>
                <Button variant="outline-danger" onClick={() => cerrarModal()}>
                  X
                </Button>
              </Modal.Header>
              <Modal.Body>
                <Row className="d-flex justify-content-center">
                  <CardMobile>{rowGuardada}</CardMobile>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="outline-danger" onClick={() => cerrarModal()}>
                  Salir
                </Button>
              </Modal.Footer>
            </Modal>
            <Modal
              show={showCard}
              fullscreen={fullscreenCard}
              onHide={() => cerrarModalCard()}
            >
              <Modal.Header>
                <Modal.Title>{tituloModalCard}</Modal.Title>
                <Button
                  variant="outline-danger"
                  onClick={() => cerrarModalCard()}
                >
                  X
                </Button>
              </Modal.Header>
              <Modal.Body>
                <Row className="d-flex justify-content-center">
                  <Col>
                    <CCCard>{dataArt}</CCCard>
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="outline-danger"
                  onClick={() => cerrarModalCard()}
                >
                  Salir
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        )}
      </Container>
    );
  } else {
    return (
      <div className="container">
        <header className="jumbotron">
          {<h2> Su usuario no se encuentra habilitado</h2>}
        </header>
      </div>
    );
  }
};

export default TablaCC;
